import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";

export default function CasesPreview() {
  const { t } = useI18n();
  const items = t.cases.items.slice(0, 4);
  return (
    <section className="border-t border-border" data-testid="cases-preview">
      <div className="container-wide py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <p className="eyebrow">{t.cases.eyebrow}</p>
            <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl tracking-[-0.02em] font-medium text-foreground leading-[1.05]">
              {t.cases.previewTitle}
            </h2>
            <p className="mt-4 max-w-xl text-muted-foreground leading-relaxed">{t.cases.previewLead}</p>
          </div>
          <div className="lg:col-span-5 flex lg:justify-end">
            <Link to="/dossiers" className="btn-ghost" data-testid="cases-preview-cta">
              {t.cases.seeAll} <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <ol className="mt-14 border-y border-border">
          {items.map((c, i) => (
            <li
              key={i}
              className="grid md:grid-cols-12 gap-x-8 gap-y-2 py-7 md:py-8 border-b border-border last:border-b-0 items-baseline group"
            >
              <span className="md:col-span-1 font-display text-2xl text-accent leading-none">{String(i + 1).padStart(2, "0")}</span>
              <p className="md:col-span-3 font-display text-xl md:text-2xl text-foreground tracking-tight">{c.city}</p>
              <p className="md:col-span-5 text-foreground/85">{c.type}</p>
              <p className="md:col-span-1 font-display text-xl text-foreground">{c.duration}</p>
              <p className="md:col-span-2 text-sm text-muted-foreground md:text-right">{c.result}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
